import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import Spinner from '../../common/spinners/Spinner';
import { useFindSocialInsurances } from '../hooks';
import { SocialInsuranceProfileView } from './SocialInsuranceProfileView';
export var SocialInsurances = function SocialInsurances(_ref) {
  var contactId = _ref.contactId,
    goToEnrollmentWorkflow = _ref.goToEnrollmentWorkflow,
    socialInsuranceLastUpdate = _ref.socialInsuranceLastUpdate,
    shouldShowLastUpdate = _ref.shouldShowLastUpdate;
  var _useFindSocialInsuran = useFindSocialInsurances(contactId),
    socialInsurances = _useFindSocialInsuran.socialInsurances,
    isLoading = _useFindSocialInsuran.isLoading;
  if (isLoading) return /*#__PURE__*/React.createElement(Spinner, null);
  if (!isEmpty(socialInsurances)) {
    return _mapInstanceProperty(socialInsurances).call(socialInsurances, function (insurance) {
      return /*#__PURE__*/React.createElement(SocialInsuranceProfileView, {
        goToEnrollmentWorkflow: goToEnrollmentWorkflow,
        insurance: insurance,
        key: "payments-insurance-".concat(insurance.id),
        lastUpdate: socialInsuranceLastUpdate,
        shouldShowLastUpdate: shouldShowLastUpdate
      });
    });
  }
  return /*#__PURE__*/React.createElement("p", {
    className: "no-insurance"
  }, "No Social Care Coverage Added.");
};
SocialInsurances.propTypes = {
  contactId: PropTypes.string.isRequired,
  goToEnrollmentWorkflow: PropTypes.func.isRequired,
  socialInsuranceLastUpdate: PropTypes.shape({
    recently_updated_at: PropTypes.string,
    recently_updated_by_name: PropTypes.string
  }),
  shouldShowLastUpdate: PropTypes.bool.isRequired
};
SocialInsurances.defaultProps = {
  socialInsuranceLastUpdate: {}
};
//# sourceMappingURL=SocialInsurances.js.map